import {
	GET_APPEAL_LETTER,
	GET_APPEAL_LETTER_SUCCESS,
	GET_APPEAL_LETTER_FAIL,
	GET_APPEAL_LETTER_RESET,
} from '../actions/getAppealLetterAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getAppealLetterReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_APPEAL_LETTER:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_APPEAL_LETTER_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_APPEAL_LETTER_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_APPEAL_LETTER_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getAppealLetterReducer;
